import * as React from 'react';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';

interface OperatedByProps {
  flightOperatedBy: string;
}

//TODO: remove p and use utik-text. UDS-2112.
export const OperatedBy = ({ flightOperatedBy }: OperatedByProps) => (
  <UitkLayoutFlexItem>
    <p className="uitk-type-200 truncate" data-test-id="operated-by">
      {flightOperatedBy}
    </p>
  </UitkLayoutFlexItem>
);
